(() => {
  const infoSection = document.querySelector('.information-section');
  if (!infoSection) return;

  const navButtons = infoSection.querySelectorAll('.information-section__nav button');
  const backgroundImages = infoSection.querySelectorAll('.background-images img');
  const contentItems = infoSection.querySelectorAll('.information-section__content__item');

  navButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      // Remove active class from all buttons
      navButtons.forEach((btn) => btn.classList.remove('active'));
      // Add active class to clicked button
      button.classList.add('active');

      // Remove active class from all background images
      backgroundImages.forEach((img) => img.classList.remove('active'));
      // Add active class to corresponding background image
      if (backgroundImages[index]) {
        backgroundImages[index].classList.add('active');
      }

      // Remove active class from all content items
      contentItems.forEach((item) => item.classList.remove('active'));
      // Add active class to corresponding content item
      if (contentItems[index]) {
        contentItems[index].classList.add('active');
      }
    });
  });
})();
